export enum PayorMethodology {
  NONE = 1,
  LEVEL = 2,
  MEDICARE = 3,
}
